import React from 'react'

const Heading = ({children}) => (
  <h2 className="text-xl my-4">{children}</h2>
)
export default Heading
